/* ==========================================================================
   ship-date-estimate.js

   Fills in the estimated ship dates for the custom fan apps, in two places:

   1. The production card under the title (snippets/production-speed-card):
      one "ships by" date per speed, for every [data-psc-date] in the card.
   2. The ship-date line above the CUSTOMIZE IT button
      (snippets/ship-date-line): the date for whichever speed is selected in
      the TierFlow widget's PRODUCTION TIMES buttons, updated as it changes.

   The line only READS the TierFlow widget. It watches for the active
   PRODUCTION TIMES button and never changes the widget, its prices or the
   cart. If that button group cannot be found, the line stays hidden.

   Dates count business days from today in Oakland (America/Los_Angeles),
   skipping weekends, the holidays below and any extra closures listed in the
   card's data-psc-closures. An order placed on a closed day counts from the
   next working day.
   ========================================================================== */
(function () {
  var parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric'
  }).formatToParts(new Date());
  var get = function (t) { return +parts.find(function (p) { return p.type === t; }).value; };
  var today = new Date(Date.UTC(get('year'), get('month') - 1, get('day')));

  var key = function (d) { return d.toISOString().slice(0, 10); };
  var nthWeekday = function (y, m, wd, n) {
    var d = new Date(Date.UTC(y, m, 1));
    d.setUTCDate(1 + ((wd - d.getUTCDay() + 7) % 7) + (n - 1) * 7);
    return d;
  };
  var lastWeekday = function (y, m, wd) {
    var d = new Date(Date.UTC(y, m + 1, 0));
    d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() - wd + 7) % 7));
    return d;
  };

  var holidays = {};
  [today.getUTCFullYear(), today.getUTCFullYear() + 1].forEach(function (y) {
    var thanks = nthWeekday(y, 10, 4, 4);
    var after = new Date(thanks); after.setUTCDate(after.getUTCDate() + 1);
    [
      new Date(Date.UTC(y, 0, 1)),   // New Year's Day
      lastWeekday(y, 4, 1),          // Memorial Day
      new Date(Date.UTC(y, 6, 4)),   // Independence Day
      nthWeekday(y, 8, 1, 1),        // Labor Day
      thanks, after,                 // Thanksgiving + Friday
      new Date(Date.UTC(y, 11, 24)), // Christmas Eve
      new Date(Date.UTC(y, 11, 25)), // Christmas
      new Date(Date.UTC(y, 11, 31))  // New Year's Eve
    ].forEach(function (d) { holidays[key(d)] = true; });
  });

  function shipBy(days, closures) {
    var closed = Object.assign({}, holidays);
    (closures || '').split(',').forEach(function (s) { s = s.trim(); if (s) closed[s] = true; });
    var isWorkday = function (d) {
      var wd = d.getUTCDay();
      return wd !== 0 && wd !== 6 && !closed[key(d)];
    };
    var next = function (d) {
      var n = new Date(d);
      do { n.setUTCDate(n.getUTCDate() + 1); } while (!isWorkday(n));
      return n;
    };
    var d = isWorkday(today) ? today : next(today);
    for (var i = 0; i < days; i++) d = next(d);
    return d.toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' });
  }

  function fillCard(card) {
    card.querySelectorAll('[data-psc-date]').forEach(function (el) {
      el.textContent = shipBy(+el.dataset.pscDate, card.dataset.pscClosures);
    });
    card.querySelectorAll('[data-psc-when]').forEach(function (el) { el.hidden = false; });
  }

  function wireLine(line, card) {
    var express = +card.dataset.pscExpress, standard = +card.dataset.pscStandard;
    var icon = line.querySelector('[data-psl-icon]');
    var date = line.querySelector('[data-psl-date]');
    var speed = line.querySelector('[data-psl-speed]');

    var update = function () {
      var active = document.querySelector('.tf-option-btn.tf-active[data-option^="PRODUCTION TIMES"]');
      if (!active) { line.hidden = true; return; }
      var isExpress = /express/i.test(active.dataset.value || '');
      icon.textContent = isExpress ? '⚡' : '📦';
      speed.textContent = isExpress ? 'Express Production' : 'Standard Production';
      date.textContent = shipBy(isExpress ? express : standard, card.dataset.pscClosures);
      line.hidden = false;
    };

    // TierFlow renders after the page loads and re-renders as options change,
    // so watch the page for its buttons appearing and for the active class
    // moving. Updates are batched to one per frame.
    var queued = false;
    var schedule = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    };
    new MutationObserver(schedule).observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['class']
    });
    update();
  }

  function init() {
    var card = document.querySelector('.psc[data-psc-express]');
    if (!card || card.dataset.pscReady) return;
    card.dataset.pscReady = '1';
    fillCard(card);
    var line = document.querySelector('.psl');
    if (line) wireLine(line, card);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
